import { Component } from '@angular/core';
import { RevealDirective } from '../../core/directives/reveal.directive';

interface Step {
  num: string;
  title: string;
  body: string;
}

@Component({
  selector: 'hx-process',
  standalone: true,
  imports: [RevealDirective],
  template: `
    <hr class="divider" />
    <section id="process">
      <div class="wrap">
        <div class="section-head reveal" appReveal>
          <p class="eyebrow">How we work</p>
          <h2>A straight line from idea to production.</h2>
        </div>
        <div class="process-list reveal" appReveal>
          @for (step of steps; track step.num) {
            <div class="process-item">
              <span class="process-num">{{ step.num }}</span>
              <h4>{{ step.title }}</h4>
              <p>{{ step.body }}</p>
            </div>
          }
        </div>
      </div>
    </section>
  `,
})
export class ProcessComponent {
  steps: Step[] = [
    { num: '01 — Discover', title: 'Scope & architecture', body: 'We map requirements against real infrastructure decisions before a line of code is written.' },
    { num: '02 — Build', title: 'Iterative development', body: 'Working environments early, with progress reported against clear milestones — not black-box sprints.' },
    { num: '03 — Deploy', title: 'Staged rollout', body: 'Dev → staging → production, with testing and sign-off at every gate.' },
    { num: '04 — Support', title: 'Stay live, stay monitored', body: 'Post-launch monitoring and a direct line to the team that built it.' },
  ];
}
